import React from 'react';
import { Button } from 'antd';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import Box from '@iso/components/utility/box';

const AppLayout = ({ children, title, history, match, buttonNewTitle, buttonNewAction }) => (
  <LayoutWrapper>
    <PageTitleBar title={title} />
    <div style={{ backgroundColor: '#fff', padding: '0 16px 12px 16px', marginBottom: 10, display: 'flex', gap: 8, justifyContent: 'flex-end', width: '100%' }}>
      {
        (buttonNewTitle) ? <Button type="primary" onClick={() => buttonNewAction()}>{buttonNewTitle}</Button> : ''
      }
    </div>
    <Box style={{ border: 'none', boxShadow: 'none', minHeight: 'calc(100vh - 220px)' }}>
      {children}
    </Box>
  </LayoutWrapper>
);

export default AppLayout;